<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center text-muted" style="margin:30px;">
                    <small>
                        © {{getYear}} {{getFooterText }}| Tüm hakları saklıdır. <span v-if="kvkkEnabled()" style="text-decoration: underline; cursor: pointer;" @click="kvkkClicked"> | Aydınlatma Metni</span><br>
                        <a href="http://www.izometri.com.tr">İzometri Bilişim</a> hizmetidir.
                    </small>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        getFooterText(){
            var hideFooterInfo = window.settings.customization?.hideFooterInfo ? true : false;
            if(hideFooterInfo)
                return "";
            else
                return "izonay.com ";
        },
        getYear(){
            var today = new Date();
            var year = today.getFullYear()
            return year
        }
    },
    methods:{
        kvkkEnabled(){
            if(window.settings.kvkkUrl || !window.settings.isOnPrem)
                return true;
            return false;
        },
        kvkkClicked(){
            this.$emit('openKvkk')
        }
    }
}  
</script>
<style scoped>
    .container, .row, .col-md-12, .text-center, .text-muted, small{
        position: relative !important;
        z-index: 0 !important;
    }
</style>